import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArticleLabelsTableComponent } from './tables/article-labels-table/article-labels-table.component';
import { UiModule } from '../../ui/ui.module';
import { CoreModule } from '../../core/core.module';
import { CoreModule as LabelsPrinterCoreModule } from '../labels-printer/core/core.module';
import { NzTooltipDirective } from 'ng-zorro-antd/tooltip';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { LabelsSharedModule } from '../labels-printer/labels-shared.module';
import { EtikettenPreviewModule } from '../etiketten/previews/etiketten-preview.module';
import { AddArticleLabelModalComponent } from './modals/add-article-label-modal/add-article-label-modal.component';
import { AddEditRoundLabelModalComponent } from './modals/add-edit-round-label-modal/add-edit-round-label-modal.component';
import { AddEditRoundLabelFormComponent } from './forms/add-edit-round-label-form/add-edit-round-label-form.component';
import { EditLabelModalComponent } from '../labels-printer/edit-label-modal/edit-label-modal.component';



@NgModule({
  declarations: [
    ArticleLabelsTableComponent,
    AddArticleLabelModalComponent,
    AddEditRoundLabelModalComponent,
    AddEditRoundLabelFormComponent
  ],
  exports: [
    ArticleLabelsTableComponent,
    AddArticleLabelModalComponent,
    AddEditRoundLabelModalComponent,
    EditLabelModalComponent
  ],
  imports: [
    CommonModule,
    UiModule,
    CoreModule,
    LabelsPrinterCoreModule,
    LabelsSharedModule,
    EtikettenPreviewModule,
    NzTooltipDirective,
    NzInputNumberModule
  ]
})
export class ArticleLabelsModule { }
